import React from 'react';
import { Package } from 'lucide-react';

export function AnalyticsPanel({ availability }) {
  return (
    <>
      {/* Entry Tier Breakdown */}
      {availability?.tiers?.length > 0 && (
        <div className="bg-[#0A0A0A] border border-[#1A1A1A] rounded-sm" data-testid="tier-breakdown">
          <div className="p-4 border-b border-[#1A1A1A]"><h2 className="text-lg font-semibold text-[#EAE7E1]">Entry Tier Breakdown</h2></div>
          <div className="overflow-x-auto">
            <table className="w-full">
              <thead className="bg-[#050505] border-b border-[#1A1A1A]"><tr>{['Tier','Price','Pax/Pass','Paid','Comp','Revenue','Left'].map(h => <th key={h} className="px-4 py-3 text-left text-xs font-medium text-[#777] uppercase">{h}</th>)}</tr></thead>
              <tbody className="divide-y divide-[#1A1A1A]">{availability.tiers.map(t => (
                <tr key={t.id}><td className="px-4 py-3 text-sm font-medium text-[#EAE7E1]">{t.tier_name}</td><td className="px-4 py-3 text-sm text-[#AFAFAF]">{t.is_comp ? 'COMP' : `$${t.price}`}</td><td className="px-4 py-3 text-sm text-[#AFAFAF]">{t.attendees_per_pass}</td><td className="px-4 py-3 text-sm text-[#EAE7E1] font-medium">{t.paid_sold || 0}</td><td className="px-4 py-3 text-sm text-[#AFAFAF]">{t.comp_sold || 0}</td><td className="px-4 py-3 text-sm font-medium text-[#D4AF37]">{t.is_comp ? '-' : `$${((t.paid_sold || 0) * t.price).toFixed(2)}`}</td><td className="px-4 py-3 text-sm text-[#EAE7E1]">{t.remaining === -1 ? 'Unlimited' : t.remaining}</td></tr>
              ))}</tbody>
            </table>
          </div>
        </div>
      )}

      {/* Add-On Summary */}
      {availability?.addons?.length > 0 && (
        <div className="bg-[#0A0A0A] border border-[#D4AF37]/20 rounded-sm" data-testid="addon-summary">
          <div className="p-4 border-b border-[#D4AF37]/20 flex items-center">
            <Package className="w-5 h-5 mr-2 text-[#D4AF37]" />
            <h2 className="text-lg font-semibold text-[#EAE7E1]">Add-On Summary</h2>
          </div>
          <div className="grid grid-cols-2 gap-3 p-4 border-b border-[#1A1A1A]">
            <div className="bg-[#050505] border border-[#1A1A1A] rounded-sm p-3">
              <div className="text-xs font-medium text-[#777] uppercase tracking-wide">Paid</div>
              <div className="mt-1 text-2xl font-bold text-[#EAE7E1]" data-testid="addon-paid-sold">{availability.addons.reduce((s, a) => s + (a.paid_sold || 0), 0)}</div>
            </div>
            <div className="bg-[#050505] border border-[#1A1A1A] rounded-sm p-3">
              <div className="text-xs font-medium text-[#777] uppercase tracking-wide">Comped</div>
              <div className="mt-1 text-2xl font-bold text-[#AFAFAF]" data-testid="addon-comp-sold">{availability.addons.reduce((s, a) => s + (a.comp_sold || 0), 0)}</div>
            </div>
            <div className="bg-[#050505] border border-[#1A1A1A] rounded-sm p-3">
              <div className="text-xs font-medium text-[#777] uppercase tracking-wide">Add-On Revenue</div>
              <div className="mt-1 text-2xl font-bold text-[#D4AF37]" data-testid="addon-total-revenue">${availability.addons.reduce((s, a) => s + ((a.paid_sold || 0) * a.price), 0).toFixed(2)}</div>
            </div>
            <div className="bg-[#050505] border border-[#1A1A1A] rounded-sm p-3">
              <div className="text-xs font-medium text-[#777] uppercase tracking-wide">Comp Value</div>
              <div className="mt-1 text-2xl font-bold text-[#AFAFAF]" data-testid="addon-comp-value">${availability.addons.reduce((s, a) => s + ((a.comp_sold || 0) * a.price), 0).toFixed(2)}</div>
            </div>
          </div>
          <div className="overflow-x-auto">
            <table className="w-full">
              <thead className="bg-[#050505] border-b border-[#1A1A1A]"><tr>{['Add-On','Price','Paid','Comp','Revenue','Comp Value','Left'].map(h => <th key={h} className="px-4 py-3 text-left text-xs font-medium text-[#777] uppercase">{h}</th>)}</tr></thead>
              <tbody className="divide-y divide-[#1A1A1A]">{availability.addons.map(a => (
                <tr key={a.id} data-testid={`addon-row-${a.id}`}>
                  <td className="px-4 py-3 text-sm font-medium text-[#EAE7E1]">{a.tier_name}</td>
                  <td className="px-4 py-3 text-sm text-[#AFAFAF]">${a.price}</td>
                  <td className="px-4 py-3 text-sm text-[#EAE7E1] font-medium">{a.paid_sold || 0}</td>
                  <td className="px-4 py-3 text-sm text-[#AFAFAF]">{a.comp_sold || 0}</td>
                  <td className="px-4 py-3 text-sm font-medium text-[#D4AF37]">${((a.paid_sold || 0) * a.price).toFixed(2)}</td>
                  <td className="px-4 py-3 text-sm text-[#AFAFAF]">${((a.comp_sold || 0) * a.price).toFixed(2)}</td>
                  <td className="px-4 py-3 text-sm text-[#EAE7E1]">{a.remaining === -1 ? 'Unlimited' : a.remaining}</td>
                </tr>
              ))}</tbody>
            </table>
          </div>
        </div>
      )}
    </>
  );
}
